import { GridReadyEvent } from "@ag-grid-community/core";
import { Component } from "@angular/core";
import { AgFns, GridOptionsExt } from "app/shared/ag-fns";
import { DialogBaseComponent, DialogParams } from "app/shared/dialog-base.component";
import { DomainService } from "app/shared/domain.service";
import { RRuleFns } from "app/shared/rrule-fns";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { RRule } from "rrule";

export interface EventScheduleDialogParams extends DialogParams {
  rruleString: string;
}
@Component({
  templateUrl: "./event-schedule-dialog.component.html",
  standalone: false,
})
export class EventScheduleDialogComponent extends DialogBaseComponent<EventScheduleDialogParams> {
  rrule!: RRule;
  // rruleOptions: Partial<Options>;
  rruleString!: string; // RFC string
  rruleText!: string; // natural language string
  rruleDates: object[] = [];
  rruleGridOptions!: GridOptionsExt;
  hasEnd!: boolean;

  isPageReady = false;

  constructor(
    public config: DynamicDialogConfig<EventScheduleDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Invoice Schedule",
      width: "500px",
      height: "665px",
    });
    this.prepare();
  }

  prepare() {
    this.rruleString = this.params.rruleString;

    this.rrule = RRule.fromString(this.rruleString);
    // this.rrule = this.fixRule(this.rrule)

    this.hasEnd = this.rrule.options.count != null || this.rrule.options.until != null;

    this.rruleGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onRruleGridReady,
      getRowId: (params) => params.data?.date,
    });

    this.calcDates();
    this.isPageReady = true;
  }

  calcDates() {
    if (this.rrule == null) {
      this.rruleGridOptions.apiX?.setGridOption("rowData", []);
      return;
    }

    try {
      this.rruleText = RRuleFns.toText(this.rrule);
    } catch (e) {
      this.rruleGridOptions.apiX?.setGridOption("rowData", []);
      return;
    }

    // rrule.all returns an infinite list if no count or untilDate
    const dates = this.rrule.all((dt, i) => (this.hasEnd ? true : i < 10));
    this.rruleDates = dates.map((dt) => {
      // needed because rrule works best with UTC dates so we need to get back to current date
      dt = new Date(dt.getTime() + Math.abs(dt.getTimezoneOffset() * 60000));
      return {
        date: dt,
        dow: RRuleFns.jsWeekDays[dt.getDay()],
      };
    });

    this.rruleGridOptions.apiX?.setGridOption("rowData", this.rruleDates);
  }

  onRruleGridReady(event: GridReadyEvent) {
    AgFns.attachGridState(this.rruleGridOptions);
    // this.rruleGridOptions.getRowId = (params) => { return params.data.rawDt?.getTime().toString(); }
    const colDefs = [
      { headerName: "Date", field: "date" },
      { headerName: "Day of Week", field: "dow" },
    ];
    // AgFns.updateColDefs(colDefs);
    // this.rruleGridOptions.apiX.setGridOption('columnDefs', colDefs);
    AgFns.initGrid(event, colDefs);
    AgFns.sizeColumnsToFit(this.rruleGridOptions);
  }

  async ok() {
    this.dialogRef.close(null);
  }

  fixRule(rrule: RRule) {
    var options = rrule.origOptions;
    if (options.interval == null) {
      options.interval = 1;
    }
    if (options.freq === RRule.MONTHLY) {
      options.bymonthday = options.bysetpos == null ? options.bymonthday || 1 : null;
      options.bysetpos = options.bymonthday == null ? options.bysetpos || 1 : null;
      if (options.bysetpos != null && (options.byweekday == null || (options.byweekday as []).length === 0)) {
        options.byweekday = [RRule.MO];
      }
    } else if (options.freq === RRule.WEEKLY) {
      options.bymonthday = null;
      options.bysetpos = null;
      if (options.byweekday?.[0] == null) {
        options.byweekday = [RRule.MO];
      }
    } else if (options.freq === RRule.DAILY) {
      options.byweekday = [];
      options.bymonthday = null;
      options.bysetpos = null;
    }
    // otherwise dtStart includes the timepart of the date.
    options.dtstart = options.dtstart || this.normalizeToUTC(this.getCurrentDate());
    const newRrule = new RRule(options);
    return newRrule;
  }

  getCurrentDate() {
    const dt = new Date();
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  }

  normalizeToUTC(date: Date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
  }

  // forceUTCToTZDate(dt) {
  //   return new Date( dt.getTime() + Math.abs(dt.getTimezoneOffset()*60000) );
  // }

  // forceUTCNoOffset(date: Date) {
  //   return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0 , 0));
  // }
}
